import { getRobotUserPermissionApi } from '@api/common';
import { authMap } from '@/config/authConfig';
const app = {
  state: {
    menuTheme: '',
    avatar: '-user',
    isBlur: false,
    currentRole: '',
    currentBot: {
      id: '',
      agent_type: ''
    },
    operates: null,
    botUserInfo: {
      companyId: ''
    },
    homelandInfo: {},
    showConversationList: false,
    isCompanyUser: false,
    companyPermissions: [],
    companyAgentPermissions: [],
    companyAiWritePermissions: [],
    companyKnowledgePermissions: [],
    companyPluginPermissions: [],
    companyDatabasePermissions: [],
    workspaceListState: null
  },
  mutations: {
    setRole(state, role) {
      state.currentRole = role;
    },
    setOperates(state, opts) {
      state.operates = opts;
    },
    setAppBlur(state, flag) {
      state.isBlur = flag;
    },
    setUserInfo(state, info) {
      Object.assign(state.botUserInfo, {
        ...info
      });
    },
    setCurrentBot(state, { id, agent_type }) {
      state.currentBot = {
        id,
        agent_type
      };
    },
    updateHomelandId(state, info) {
      state.homelandInfo = info;
    },
    updateConversionListStatus(state, status) {
      state.showConversationList = status ?? !state.showConversationList;
    },
    setIsCompanyUser(state, isCompanyUser) {
      state.isCompanyUser = !!isCompanyUser;
    },
    setCompanyPermissions(state, permissions) {
      state.companyPermissions = Array.isArray(permissions)
        ? [...permissions]
        : [];
    },
    setCompanyAgentPermissions(state, permissions) {
      state.companyAgentPermissions = Array.isArray(permissions)
        ? permissions.map(item => item.englishName)
        : [];
    },
    setCompanyAiWritePermissions(state, permissions) {
      state.companyAiWritePermissions = Array.isArray(permissions)
        ? permissions.map(item => item.englishName)
        : [];
    },
    setCompanyKnowledgePermissions(state, permissions) {
      state.companyKnowledgePermissions = Array.isArray(permissions)
        ? permissions.map(item => item.englishName)
        : [];
    },
    setCompanyPluginPermissions(state, permissions) {
      state.companyPluginPermissions = Array.isArray(permissions)
        ? permissions.map(item => item.englishName)
        : [];
    },
    setCompanyDatabasePermissions(state, permissions) {
      state.companyDatabasePermissions = Array.isArray(permissions)
        ? permissions.map(item => item.englishName)
        : [];
    },
    setWorkspaceListState(state, listState) {
      state.workspaceListState = listState;
    },
    clearWorkspaceListState(state) {
      state.workspaceListState = null;
    }
  },
  actions: {
    getPermission: async ({ state, commit }) => {
      commit('setOperates', null);
      const auth = await getRobotUserPermissionApi({
        robot_id: state.currentBot.id,
        agent_type: state.currentBot.agent_type,
        homeland_id: state.homelandInfo.homeland
      });
      const operates = [];
      if (auth.config === 3) {
        operates.push(authMap.botConfig);
      }
      if (auth.self_chatflow === 3) {
        operates.push(authMap.flowSelf);
      }
      if (auth.history === 3) {
        operates.push(authMap.botHistory);
      }
      if (auth.plugin === 3) {
        operates.push(authMap.pluginPublic);
      }
      if (auth.chatflow === 3) {
        operates.push(authMap.flowPublic);
      }
      if (auth.homeland && Object.keys(auth.homeland).length > 0) {
        Object.keys(auth.homeland).forEach(key => {
          if (auth.homeland[key] === 3) {
            operates.push(authMap[`homeland_${key}`]);
          }
        });
      }
      commit('setOperates', operates);
    }
  },
  getters: {
    userExpireTime(state) {
      return state.botUserInfo.expire_time;
    },
    authBaseInfo: state => {
      return {
        homelandInfo: state.homelandInfo,
        botId: state.currentBot
      };
    },
    authIsReady: state => state.operates instanceof Array,
    operates: state => state.operates ?? [],
    avatar: state => state.avatar,
    botUserInfo: state => state.botUserInfo,
    homelandInfo: state => state.homelandInfo,
    token: state => state.botUserInfo.token,
    isCompanyUser: state => state.isCompanyUser,
    companyPermissions: state => state.companyPermissions,
    companyAgentPermissions: state => state.companyAgentPermissions,
    companyAiWritePermissions: state => state.companyAiWritePermissions,
    companyKnowledgePermissions: state => state.companyKnowledgePermissions,
    companyPluginPermissions: state => state.companyPluginPermissions,
    companyDatabasePermissions: state => state.companyDatabasePermissions,
    workspaceListState: state => state.workspaceListState
  }
};
export default app;
